import InvoiceProduct from '@/models/InvoiceProduct';

const LOAD_INVOICE_RESOURCES = 'load_invoice_resources';

const LOAD_INVOICE_RESOURCES_REQUEST = 'load_invoice_resources_request';
const LOAD_INVOICE_RESOURCES_SUCCESS = 'load_invoice_resources_success';
const LOAD_INVOICE_RESOURCES_ERROR = 'load_invoice_resources_error';

export { LOAD_INVOICE_RESOURCES };

export default {
    state: {
        loading: false,
        invoice_products: [],
    },
    mutations: {
        [LOAD_INVOICE_RESOURCES_REQUEST] (state) {
            state.loading = true;
        },
        [LOAD_INVOICE_RESOURCES_SUCCESS](state, { invoice_products }) {
            state.loading = false;
            state.invoice_products = invoice_products;
        },
        [LOAD_INVOICE_RESOURCES_ERROR] (state, errors) {
            state.loading = false;
        }
    },
    actions: {
        [LOAD_INVOICE_RESOURCES] ({ commit, state }) {
            commit(LOAD_INVOICE_RESOURCES_REQUEST);

            let invoice_products_promise = InvoiceProduct.collection();
            Promise.all([invoice_products_promise])
                .then(values => {
                    commit(LOAD_INVOICE_RESOURCES_SUCCESS, {
                        invoice_products: values[0].items
                    });
                }).catch(({ status, errors }) => {
                    commit(LOAD_INVOICE_RESOURCES_ERROR, errors);
                });
        },
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/invoice-resources.js